import React from 'react';
import PropTypes from 'prop-types';
import { GoalWithoutThreshold } from 'Components/UI/guidedHouseholdReview/goalWithoutThreshold';

export const GuidedHouseholdReviewDraggableGoal = ({ stepResource }) => {
  return <GoalWithoutThreshold resource={stepResource} />;
};

GuidedHouseholdReviewDraggableGoal.propTypes = {
  stepResource: PropTypes.object.isRequired,
};
